import React  from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {  RemoveDriverEmployee } from '../../../../../reduxToolkit/Vehicle/VehicleApi';
import CustomModal from '../../../../../components/Modal/CustomModal';
import CustomDescriptionLabel from '../../../../../components/CustomDescriptionLabel';
import { DeleteDocumentById } from './../../../../../reduxToolkit/DocumentPanel/DocumentPanelApi';

const RemoveDriver = (props) => {
    // tittle_modal is the heading name
    // modal_name is the condition for different calling
    const { title_modal, modal_name, data, setDeleted, onHide } = props;

    const dispatch = useDispatch();
    const { t } = useTranslation();

    // delete handler function
    const handleDelete = () => {
        if (modal_name === 'delete_image') {
            const payload = {
                id: data?.id,
                option: 'vehicle',
            };
            dispatch(DeleteDocumentById(payload)).then(({ payload: { data } }) => {
                if(data){
                    setDeleted(prev => prev + 1);
                    onHide();
                }
            });
        }
        if (modal_name === 'remove_driver') {
            dispatch(RemoveDriverEmployee(data?.id));
            onHide();
        }
    };

    return (
        <CustomModal
            title={title_modal}
            size='md'
            buttonConfirm='confirm'
            {...props}
            onConfirm={() => { handleDelete()}}
        >
            {modal_name === 'delete_image' &&
                <div className={"col-12 center-text"}>
                    <CustomDescriptionLabel trans={t("confirm_the_action_to_delete_the_image_that_belongs_to_this_vehicle")}/>
                </div>
            }
            {modal_name === 'remove_driver' && (
                <div className={"row"}>
                    <div className={"col-12"}>
                        <p className='d-flex justify-content-center align-content-center'>
                            {t('confirm_the_action_to_remove_the_driver')}
                            <span className={'ibl-font-w-600 font-color-general-950 mx-1'}> {t(data?.name).toLowerCase()}</span>
                            {t('that_belong_to_this_card')}
                        </p>
                    </div>
                </div>
            )}
        </CustomModal>
    );
};

export default RemoveDriver;
